import React from 'react'

import { Card, CardHeading, CardContent } from '@components/layout/Card'
import { LineChartStacked } from '@components/charts/LineChartStacked'

import { Text } from '@UILibrary/Text'
import { buildLineChartjsStackedOptionsProp } from './charts/options'
import { buildFinancialHealthHeatmapDataProp } from './charts/data'

interface FinancialHealthDistributionByCount {
  labels: string[]
  datasets: any[]
}

interface FinancialHealthHeatmapByCountProps {
  financialHealthDistributionByCount: FinancialHealthDistributionByCount
}

export const FinancialHealthHeatmapByCount: React.FC<FinancialHealthHeatmapByCountProps> = (props) => {
  const { labels, datasets } = props.financialHealthDistributionByCount
  const datasetsWithColors = buildFinancialHealthHeatmapDataProp(datasets)

  return (
    <Card>
      <CardHeading>
        <Text heading4a colour="secondary-main" as="h3" margin="none">
          Employee count by retirement readiness
        </Text>
        <Text body as="p">
          Actual number of team members in each financial health category over time.
        </Text>
      </CardHeading>
      <CardContent>
        <LineChartStacked
          height="medium"
          labels={labels}
          data={datasetsWithColors}
          options={buildLineChartjsStackedOptionsProp(labels, datasetsWithColors)}
        />
        <Text bodySmall as="p" textAlign='center' margin='none'>
          (click legends to toggle on and off)
        </Text>
      </CardContent>
    </Card>
  )
}
